import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Password = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const handleForgotPassword = async () => {
        // 1. Validações básicas
        if (!email || !newPassword || !confirmPassword) {
            alert("Por favor, preencha todos os campos.");
            return;
        }

        if (newPassword !== confirmPassword) {
            alert("As senhas não coincidem!");
            return;
        }

        if (newPassword.length < 6) {
            alert("A senha deve ter pelo menos 6 caracteres.");
            return;
        }

        setLoading(true);

        try {
            const response = await fetch("https://hubdaive.com.br/api/reset-password", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    username: email,
                    new_password: newPassword
                })
            });

            const data = await response.json();

            if (response.ok) {
                alert("Senha redefinida com sucesso! Redirecionando para o login...");
                navigate('/')
                // ou simplesmente mudar o estado que controla a tela atual
            } else {
                alert("Erro: " + (data.detail || "Não foi possível redefinir a senha."));
            }
        } catch (err) {
            console.error("Erro na recuperação:", err);
            alert("Erro ao conectar com o servidor.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <h2 style={styles.title}>Recuperar Senha</h2>
                <p style={styles.subtitle}>Digite seu e-mail e a nova senha abaixo.</p>

                <div style={styles.inputGroup}>
                    <input
                        type="text"
                        placeholder="E-mail cadastrado"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        style={styles.input}
                    />
                </div>

                <div style={styles.inputGroup}>
                    <input
                        type="password"
                        placeholder="Nova Senha"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        style={styles.input}
                    />
                </div>

                <div style={styles.inputGroup}>
                    <input
                        type="password"
                        placeholder="Confirmar Nova Senha"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        style={styles.input}
                    />
                </div>

                <button 
                    onClick={handleForgotPassword} 
                    disabled={loading}
                    style={{
                        ...styles.button,
                        backgroundColor: loading ? '#555' : '#007AFF'
                    }}
                >
                    {loading ? "Processando..." : "Redefinir Senha"}
                </button>

                <button 
                    onClick={() => navigate('/')} 
                    style={styles.linkButton}
                >
                    Voltar para o Login
                </button>
            </div>
        </div>
    );
};

// Estilos básicos seguindo a estética dark que você está usando
const styles = {
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#1a1a1a',
        color: '#fff',
        fontFamily: 'Helvetica, Arial, sans-serif'
    },
    card: {
        backgroundColor: '#262626',
        padding: '40px',
        borderRadius: '15px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.3)',
        width: '100%',
        maxWidth: '400px',
        textAlign: 'center',
        border: '1px solid #333'
    },
    title: {
        marginBottom: '10px',
        fontSize: '24px'
    },
    subtitle: {
        color: '#aaa',
        fontSize: '14px',
        marginBottom: '30px'
    },
    inputGroup: {
        marginBottom: '15px'
    },
    input: {
        width: '100%',
        padding: '12px 15px',
        borderRadius: '8px',
        border: '1px solid #444',
        backgroundColor: '#121212',
        color: '#fff',
        fontSize: '16px',
        boxSizing: 'border-box'
    },
    button: {
        width: '100%',
        padding: '12px',
        borderRadius: '8px',
        border: 'none',
        color: '#fff',
        fontSize: '16px',
        fontWeight: 'bold',
        cursor: 'pointer',
        marginTop: '10px',
        transition: 'background 0.3s'
    },
    linkButton: {
        background: 'none',
        border: 'none',
        color: '#007AFF',
        marginTop: '20px',
        cursor: 'pointer',
        fontSize: '14px'
    }
};

export default Password;